import { Stack } from 'braid-design-system';
import { LocationLookup } from 'wingman-fe';

import { SectionHeadingLink } from './SectionHeadingLink/SectionHeadingLink.tsx';

import { useEnvironmentConfig } from '#src/hooks/environment.tsx';

export const LocationLookupSection = () => {
  const { seekAnzSchemeId } = useEnvironmentConfig();

  return (
    <Stack space="large">
      <SectionHeadingLink href="/use-cases/job-posting/locations#location">
        Location lookup
      </SectionHeadingLink>

      <LocationLookup schemeId={seekAnzSchemeId} />
    </Stack>
  );
};
